const basicTheme = {
  background: '#fff',
  secondaryBg: 'rgba(219, 219, 219, 0.2)',
  muted: '#6c757d',
  border: '#dbdbdb',
  accent: '#6347EB',
  secondaryAccent: '#FF9100',
  outline: '#56BADA',
  textPrimary: '#000',
}
export default basicTheme;